import { ModelRelationshipFactory } from '/@/modules/core/app/models/relationships/ModelRelationshipFactory';
import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class BaseDBTModel extends BaseEntityModel {
  setRelationships(instance: BaseDBTModel, model: Partial<BaseDBTModel>, modelName: string): void {
    Object.assign(instance, ModelRelationshipFactory.build(modelName, model));
  }
}
